import _ from 'lodash';

export default function getColors(data) {
    const colors = [];

    function getColorsFromValue(value) {
        if (value) {
            if (typeof value === "string") {
                if ((/^#([0-9a-f]{6}|[0-9a-f]{3})$/i).exec(value)) {
                    colors.push(value);
                }
            } else if (_.isArray(value)) {
                _.each(value, v => getColorsFromValue(v));
            } else if (typeof value === "object") {
                getColorsFromObject(value);
            }
        }
    }

    function getColorsFromObject(obj) {
        if (obj) {
            for (let p in obj) {
                getColorsFromValue(obj[p]);
            }
        }
    }

    getColorsFromObject(data);

    return _.uniq(colors);
}